var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.json)?_c('vx-no-info-dash'):_c('vx-json-viewer',{attrs:{"value":_vm.json,"expand-depth":4,"expanded":"","copyable":""}})}
var staticRenderFns = []

export { render, staticRenderFns }